/*---

  Scripts for the customer account

  Louis-Charles Blais [info@22agencecreative.ca]

---*/


// Tab switching
function switchAccountTab() {
  let tabElements = document.querySelectorAll('[data-account-tab-id]');
  for (let i = 0; i < tabElements.length; i++) {
    tabElements[i].classList.remove('active');
    if (tabElements[i].dataset.accountTabId == event.target.dataset.accountTabId) {
      tabElements[i].classList.add('active');
    }
  }
}


// Add to order logic
let productSearchBar = document.querySelector('#products-to-add-input');
let searchResultsContainer = document.querySelector('.products-to-add-results');
let waiting = false;

function searchProducts() {
  searchResultsContainer.innerHTML = '';
  
  if (productSearchBar.value.length >= 2 && !waiting) {
    
    fetch(window.Shopify.routes.root + "search/suggest.json?q=" + productSearchBar.value + "&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,variants.title")
      .then((response) => response.json())
      .then((suggestions) => {
        let productSuggestions = suggestions.resources.results.products;

        for (let i = 0; i < productSuggestions.length; i++) {
          let productCard = document.createElement("div");
          productCard.className = 'product';
          productCard.dataset.handle = productSuggestions[i].handle;
          productCard.setAttribute('onclick','addProduct()');

          let title = document.createElement("span");
          title.className = 'title';
          title.innerHTML = productSuggestions[i].title;
          productCard.appendChild(title);

          let vendor = document.createElement("span");
          vendor.className = 'vendor';
          vendor.innerHTML = productSuggestions[i].vendor;
          productCard.appendChild(vendor);

          searchResultsContainer.appendChild(productCard);
        }
      }
    );
    
    waiting = true;
    setTimeout(() => {
      waiting = false;
    }, "200");
  }
}

let productsToAddContainer = document.querySelector('.products-to-add-list');

function addProduct() {
  fetch(window.Shopify.routes.root + 'products/' + event.target.dataset.handle + '.js')
    .then(response => response.json())
    .then((product) => {
      
      let productCard = document.createElement("div");
      productCard.className = 'product';
  
      let title = document.createElement("span");
      title.className = 'title';
      title.innerHTML = product.title;
      productCard.appendChild(title);
  
      let vendor = document.createElement("span");
      vendor.className = 'vendor';
      vendor.innerHTML = product.vendor;
      productCard.appendChild(vendor);
  
      let variantSelector = document.createElement("select");
      variantSelector.name = 'products[][variant]';
      variantSelector.className = 'variant-selector';
      for (let i = 0; i < product.variants.length; i++) {
        let variant = document.createElement("option");
        variant.value = product.variants[i].title;
        variant.innerHTML = product.variants[i].title;
        variantSelector.appendChild(variant);
      }
      productCard.appendChild(variantSelector);

      let quantity = document.createElement("input");
      quantity.name = 'products[][quantity]';
      quantity.type = 'number';
      quantity.value = 1;
      productCard.appendChild(quantity);

      let deleteButton = document.createElement("i");
      deleteButton.className = 'iconoir-trash';
      deleteButton.setAttribute('onclick','deleteProduct()');
      productCard.appendChild(deleteButton);

      let inputElementTitle = document.createElement("input");
      inputElementTitle.name = 'products[][title]';
      inputElementTitle.type = 'hidden';
      inputElementTitle.value = product.title;
      productCard.appendChild(inputElementTitle);

      let inputElementVendor = document.createElement("input");
      inputElementVendor.name = 'products[][vendor]';
      inputElementVendor.type = 'hidden';
      inputElementVendor.value = product.vendor;
      productCard.appendChild(inputElementVendor);
  
      productsToAddContainer.appendChild(productCard);

      productSearchBar.value = '';
      searchProducts();
    }
  );
}

function deleteProduct() {
  event.target.parentElement.remove();
}

let productsForm = document.querySelector('#add-to-order-form');
if (productsForm) {
  productsForm.addEventListener(
    'submit',
    (event) => {
      event.preventDefault();
      fetch(
        "https://webhooks.mechanic.dev/9107ba61-52d5-48a1-b704-f09b7576f351",
        {
          method: 'POST', 
          body: new FormData(productsForm),
        }
      ).then((response) => {
        console.log('Sending data to Mechanic: Success!', response);
      }).catch((error) => {
        console.error('Sending data to Mechanic: Error!', error);
      }).finally(() => {
        // confirmation
        document.querySelector('.add-to-order .submit').style.display = 'none';
        document.querySelector('.add-to-order .success').style.display = 'block';
      });
    },
  );
}